/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseRequestParams,
    PressReleaseRequestParamsFromJSON,
    PressReleaseRequestParamsFromJSONTyped,
    PressReleaseRequestParamsToJSON,
} from './PressReleaseRequestParams';

/**
 * プレスリリース新規作成APIのリクエストボディ
 * @export
 * @interface CreatePressReleaseRequestBody
 */
export interface CreatePressReleaseRequestBody {
    /**
     * 
     * @type {PressReleaseRequestParams}
     * @memberof CreatePressReleaseRequestBody
     */
    pressRelease: PressReleaseRequestParams;
    /**
     * コンフリクト検知用のタイムスタンプ
     * @type {number}
     * @memberof CreatePressReleaseRequestBody
     */
    editStartedAt: number;
    /**
     * テストメールを送信フラグ
     * @type {boolean}
     * @memberof CreatePressReleaseRequestBody
     */
    shouldSendTestMail?: boolean;
    /**
     * テストメール送信先
     * @type {string}
     * @memberof CreatePressReleaseRequestBody
     */
    testMailAddress?: string;
}

export function CreatePressReleaseRequestBodyFromJSON(json: any): CreatePressReleaseRequestBody {
    return CreatePressReleaseRequestBodyFromJSONTyped(json, false);
}

export function CreatePressReleaseRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePressReleaseRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressRelease': PressReleaseRequestParamsFromJSON(json['press_release']),
        'editStartedAt': json['edit_started_at'],
        'shouldSendTestMail': !exists(json, 'should_send_test_mail') ? undefined : json['should_send_test_mail'],
        'testMailAddress': !exists(json, 'test_mail_address') ? undefined : json['test_mail_address'],
    };
}

export function CreatePressReleaseRequestBodyToJSON(value?: CreatePressReleaseRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release': PressReleaseRequestParamsToJSON(value.pressRelease),
        'edit_started_at': value.editStartedAt,
        'should_send_test_mail': value.shouldSendTestMail,
        'test_mail_address': value.testMailAddress,
    };
}

